export default __webpack_public_path__ + "static/media/end.470fa674.gif";